<template>
  <v-flex class="pl-2 pr-2">
    <v-layout align-start justify-start row class="ml-3 mb-4">
      <v-icon color="primary" style="font-size: 50px;">show_chart</v-icon>
      <h2
        :style="`color: ${$vuetify.theme.primary}`"
        class="mt-2 ml-2"
      >{{$translate('STATISTICS_OF_PARTNERS')}}</h2>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs8>
        <canvas id="partner-chart" devicePixelRatio="10"></canvas>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import _ from "lodash";
import { mapGetters } from "vuex";
import Chart from "chart.js";
import "chartjs-plugin-zoom";

export default {
  name: "Statistics_Partner",
  components: {},
  computed: mapGetters({
    currentAccountId: "getCurrentAccountId",
  }),
  props: ["partners"],
  data() {
    return {
      ctx: {},
      partnerGraph: null,
      graphsData: {
        type: "bar",
        data: {
          labels: ["Statistics of Partners"],
          datasets: [
            {
              label: "Unregistered",
              data: [],
              borderColor: 'rgb(255, 0, 0)',
              backgroundColor: 'rgb(255, 0, 0)',
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            },
            {
              label: "Registered",
              data: [],
              borderColor: 'rgb(0, 255, 0)',
              backgroundColor: 'rgb(0, 255, 0)',
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            },
            {
              label: "Basic",
              data: [],
              borderColor: 'rgb(255, 255, 0)',
              backgroundColor: 'rgb(255, 255, 0)',
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            },
            {
              label: "Premium",
              data: [],
              borderColor: 'rgb(255, 153, 0)',
              backgroundColor: 'rgb(255, 153, 0)',
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            },
            {
              label: "Total",
              data: [],
              borderColor: 'rgb(0, 0, 255)',
              backgroundColor: 'rgb(0, 0, 255)',
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            }
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Statistics of Partners",
            fontSize: 20,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  display: true,
                  fontSize: 9,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  callback: function (value, index, values) {
                    return value;
                  },
                  display: true,
                  beginAtZero: true,
                  stepSize: 10,
                },
              },
            ],
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "x",
              },
              zoom: {
                enabled: true,
                mode: "x",
              },
            },
          },
        },
      },
    };
  },

  mounted() {
    this.updateGraphs();
  },

  methods: {
    updateGraphs() {
      this.ctx = document.getElementById("partner-chart");
      this.graphsData.data.datasets.forEach(element => {
        element.data = [];
      });

      let nrOfUnregistered = 0, nrOfRegistered = 0, nrOfBasic = 0, nrOfPremium = 0;
      this.partners.forEach(partnerObj => {
        switch(Number(partnerObj.PartnerLevel)) 
        {
          case 0:
            nrOfUnregistered++;
            break;
          case 1:
            nrOfRegistered++;
            break;
          case 2:
            nrOfBasic++;
            break;
          case 3:
            nrOfPremium++;
            break;
          default:
            break;
        }
      });

      this.graphsData.data.datasets[0].data.push(nrOfUnregistered);
      this.graphsData.data.datasets[1].data.push(nrOfRegistered);
      this.graphsData.data.datasets[2].data.push(nrOfBasic);
      this.graphsData.data.datasets[3].data.push(nrOfPremium);
      this.graphsData.data.datasets[4].data.push(this.partners.length);

      console.log("graphsData: ", this.graphsData);

      if (this.partnerGraph) this.partnerGraph.destroy();
      this.partnerGraph = new Chart(this.ctx, this.graphsData);
      this.partnerGraph.update();
    },
  },
};
</script>

<style lang="scss", scoped>
.center_table > td {
  text-align: center;
}
</style>
